import { Component, Input } from '@angular/core';
import { EmissionFactorDatabaseDto } from 'app/@types/dto/emission-factor-hierarchical-structure-dto.model';

@Component({
    selector: 'app-database-card',
    templateUrl: './database-card.component.html',
    styleUrls: ['./database-card.component.scss'],
    standalone: false,
})
export class DatabaseCardComponent {
    @Input() database?: EmissionFactorDatabaseDto;
    @Input() dcarbAdmin: boolean = false;
}
